import React,{Component} from 'react';
import './AdminOrders.css';
import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import assignblue from '../../../image/assignblue.svg'
import searchicon from '../../../image/searchicon.svg'
import {Link} from 'react-router-dom';
import axios from 'axios'
import {LinkAPI} from '../../../API/API'
import HandleRes from '../../Components/HandleRes/HandleRes';
import barcode from '../../../image/bar-code.svg'
import { QRCode } from "react-qr-svg";

var moment = require('moment');
 
class AdminOrders extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            dataprint:[],
            search:'',
            dataorders:[],
            dataordersafterfilter:[],
            checkAll:false,
            status:'',
            collect:-1,
            currentPage: 1,
            ordersPerPage: 8,
            networkError: false,
            errordatamessage: false,
            hasError: false,
        };
        this.handleClick = this.handleClick.bind(this);

            const Token =localStorage.getItem("AdminTokenKayn")
            axios.get(`${LinkAPI}/api/admin/getorders`,{
                headers:{
                  Authorization:`${Token}`
                }
              }).then(res =>{
                this.setState({
                    data: res.data.reverse(),
                    dataorders: res.data.reverse(),

                    dataordersafterfilter: res.data.reverse(),
                    networkError: false,
                    errordatamessage: false,
                    hasError: false,
                  })
                  }).catch(error=>{
                  if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {
                    localStorage.removeItem("AdminTokenKayn")
                    window.location.replace("/Admin/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext: error.response.data.message,
                        failedreasonerror: '',
        
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                  })
                } 
                handleClick(event) {
                    this.setState({
                      currentPage: Number(event.target.value)
                    });
                  }
                 
                handleChange = event => {
                    this.setState({
                        [event.target.name]  : event.target.value
                    });
                };
                handlefilterstauts = event => {
                    const {value} =event.target
                    this.setState({
                        status  : value
                    },()=>{this.filterselect()});
                         
                };
                filterselectDate=event =>{
                    if(event.target.value===moment().format('L')){
                        let  selectFilter = this.state.data.filter(order=>
                            moment(order.pickupDate).format('L')===moment().format('L')
                        )
                        this.setState({
                            dataorders: selectFilter,
                            currentPage: 1,
        
                        },()=>{this.filterselect()});
                    }else if(event.target.value===moment().add(1, 'days').format('L')){
                        let  selectFilter = this.state.dataorders.filter(order=>
                              moment(order.pickupDate).format('L')===moment().add(1, 'days').format('L')
        
                        )
                        this.setState({
                            dataorders: selectFilter,
                            currentPage: 1,
                        },()=>{this.filterselect()});
                    }else{
                        this.setState({
                            dataorders: this.state.data,
                            currentPage: 1,
                        },()=>{this.filterselect()});
                    }
                }
                filterselect=() =>{
                    if(this.state.status==="draft"){
                        let  selectFilter = this.state.dataorders.filter(order=>
                            order.status===0
                        )
                        this.setState({
                            dataordersafterfilter: selectFilter,
                            currentPage: 1,
        
                        });
                    }else if(this.state.status==="placed"){
                        let  selectFilter = this.state.dataorders.filter(order=>
                            order.status===1
                        )
                        this.setState({
                            dataordersafterfilter: selectFilter,
                            currentPage: 1,
                        });
                        
                    }else if(this.state.status==="assign-B"){
                        let  selectFilter = this.state.dataorders.filter(order=>
                            order.status===2
                        )
                        this.setState({
                            dataordersafterfilter: selectFilter,
                            currentPage: 1,
                        });
                        
                    }else if(this.state.status==="pickedup"){
                        let  selectFilter = this.state.dataorders.filter(order=>
                            order.status===3
                        )
                        this.setState({
                            dataordersafterfilter: selectFilter,
                            currentPage: 1,
                        });
                        
                    }else if(this.state.status==="warehouse"){
                        let  selectFilter = this.state.dataorders.filter(order=>
                            order.status===4
                        )
                        this.setState({
                            dataordersafterfilter: selectFilter,
                            currentPage: 1,
                        });
                        
                    }else if(this.state.status==="assign-D"){
                        let  selectFilter = this.state.dataorders.filter(order=>
                            order.status===5
                        )
                        this.setState({
                            dataordersafterfilter: selectFilter,
                            currentPage: 1,
                        });
                        
                    }else if(this.state.status==="O-F-delivery"){
                        let  selectFilter = this.state.dataorders.filter(order=>
                            order.status===6
                        )
                        this.setState({
                            dataordersafterfilter: selectFilter,
                            currentPage: 1,
                        });
                        
                    }else if(this.state.status==="delivered"){
                        let  selectFilter = this.state.dataorders.filter(order=>
                            order.status===7
                        )
                        this.setState({
                            dataordersafterfilter: selectFilter,
                            currentPage: 1,
                        });
                    }else if(this.state.status==="failed"){
                        let  selectFilter = this.state.dataorders.filter(order=>
                            order.status===8&&order.failedstatus===1
                        )
                        this.setState({
                            dataordersafterfilter: selectFilter,
                            currentPage: 1,
                        });
                    }else if(this.state.status==="canceled"){
                        let  selectFilter = this.state.dataorders.filter(order=>
                            order.status===9
                        )
                        this.setState({
                            dataordersafterfilter: selectFilter,
                            currentPage: 1,
                        });
                    }else{
                        this.setState({
                            dataordersafterfilter: this.state.dataorders,
                            currentPage: 1,
                        });
                    }
                }
               
                changecollect=()=>{
                    if(this.state.collect===-1){
                        this.setState({
                            collect:0
                          });
                    }else{
                        this.setState({
                            collect:-1
                          });
                    }
                }
                handleaddalltoprint=(x)=>{
                    if(this.state.checkAll===false){
                        
                        this.setState({
                            dataprint: x,
                            checkAll:true
                        })
                        
                    }
                        else{

                            this.setState({
                                dataprint: [],
                                checkAll:false
                            })
                        }
                    
                }


                handleaddtoprint=(x)=>{
                  

                                let  objectexist =this.state.dataprint.indexOf(x)
                                if(objectexist===-1){
                                    let addobject =this.state.dataprint.concat(x)
                                this.setState({
                                    dataprint: addobject
                                })
                                }else{
                                    let  removeobject =this.state.dataprint.filter(
                                        (contact)=>{
                                            return contact.ordernumber.toString().indexOf(x.ordernumber.toString())!==0;
                                        }
                                        
                                    )   
                                    this.setState({
                                        dataprint: removeobject
                                    })

                                }
                                    


                    ;
                }
                print=()=>{
                    var content = document.getElementById("divcontents");
                    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
                    pri.document.open();
                    pri.document.write('<style> .col-md-6   {width: 50%;display: inline-block} p  {font-size: 15px; display: inline-block;   font-family: tahoma;}  button  ,.Receiverde  {visibility: hidden;} </style>');
                    pri.document.write(content.innerHTML);
                    pri.document.close();
                    pri.focus();
                    pri.print();
                }
    render(){
        
        const handle_state=[['draft','placed','assign-P','pickedup','warehouse','assign-D','O-F-delivery','delivered','failed','canceled','trash','replaced'],
                            ['draft','placed','assign-P','pickedup','warehouse','assign-D','O-F-delivery','delivered','failed','canceled','trash','replaced'],
                            ['draft','trash','trash','trash','trash','trash','trash','trash','trash','trash','trash','trash'],
                            ['draft','placed','assign-P','pickedup','warehouse','assign-D','O-F-delivery','delivered','failed','canceled','trash','replaced'],
                            ['draft','placed','assign-P','pickedup','warehouse','assign-D','O-F-delivery','delivered','failed','canceled','trash','replaced'],
                            ['draft','placed','assign-P','pickedup','warehouse','assign-D','O-F-delivery','delivered','failed','canceled','trash','replaced']]
       
    let  dataordersFilter = this.state.dataordersafterfilter.filter(order=>
        order.amount>this.state.collect
    )
        let  filteredContantsname = dataordersFilter.filter(
            (contact)=>{
                return contact.ownerData.name.toLowerCase().indexOf(this.state.search.toLowerCase())!==-1;
            }
        )
        let  filteredContantsphone = dataordersFilter.filter(
            (contact)=>{
                return contact.ownerData.name.toLowerCase().indexOf(this.state.search.toLowerCase())!==-1;
            }
        )
        let  filteredContantsordernumber = dataordersFilter.filter(
            (contact)=>{
                return contact.ordernumber.toString().indexOf(this.state.search)!==-1;
            }
        )
        
        
       
       
        
        // let filteredContants = filteredContantsname.concat(filteredContantsphone);
        let filteredContants = [...new Set([...filteredContantsordernumber,...filteredContantsphone,...filteredContantsname])]
        const {  currentPage, ordersPerPage } = this.state;
        // Logic for displaying current todos
        const indexOfLastorders = currentPage * ordersPerPage;
        const indexOfFirstorders = indexOfLastorders - ordersPerPage;
        const currentdataorders = filteredContants.slice(indexOfFirstorders, indexOfLastorders);
        const renderdataorders = currentdataorders.map((x, i) => {
          return       <tr key={i}>
          <td className=""><input className="mx-1 rela" type="checkbox" onClick={()=>this.handleaddtoprint(x)} id="invalidCheck2" checked={this.state.dataprint.indexOf(x)!==-1?"checked":""} />
          <Link to={"/Admin/OrderDetail/"+x.ordernumber}> {x.ordernumber}</Link></td>
          <td> <Link to={"/Admin/OrderDetail/"+x.ordernumber}>{x.reciver.name}</Link></td>
          <td>{ moment(x.pickupDate).format("ll")}</td>
          <td>{x.reciver.name}</td>
          <td>{x.pickupLocation.address_name}</td>
          <td>{x.amount}</td> 
          <td className="text-center"><span className={"badge-pill "+handle_state[x.failedstatus][x.status]}>{handle_state[x.failedstatus][x.status]}</span></td>
          <td>{x.totalPrice}</td>
          <td className="text-center"><Link to={"/Admin/EditOrder/"+x.ordernumber}><img className="" src={assignblue} alt="assignblue"/></Link></td>
          </tr>;
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(filteredContants.length / ordersPerPage); i++) {
          pageNumbers.push(i);
        }
        const renderPageNumbers = pageNumbers.map(number => {
            return ( <option key={number} value={number} > {number} </option> );
          });
       
       
       
       
       
       
       
       
       
       
        return(
            <div className="AppEN container-fluid px-0">
                    <div className="row   mx-0">
                        <div className="col-md-1 px-0 ">
                        <NabarAdmin/>
                        </div>
                        <div className="Orders Admin col-md-11 px-lg-5 " >
                        <AdminHeaderTool/>
                            <h3 className=" fontsize9 my-2">Orders</h3>
                            <div className="filter px-4 row"> 
                                <p className="fontsize11 font-weight-bold mt-2 col-lg-1 col-md-2">View</p>
                                    <div className="col-lg-2 col-md-5">
                                        <div className="form-group  ">
                                        <select id="inputState" className="form-control  badge-pill  text-muted" onClick={this.filterselectDate}>
                                                <option value="all">Date</option>
                                                <option value="all">ALL</option>
                                                <option value={moment().format('L')}>Today</option>
                                                <option value={moment().add(1, 'days').format('L')}>Tomorrow</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-5">
                                        <div className="form-group  ">
                                        <select id="inputState" onChange={this.handlefilterstauts} className="form-control  badge-pill  text-muted">
                                                <option defaultValue>STATUS </option> 
                                                <option value="draft">draft</option>
                                                <option value="placed">placed</option>
                                                <option value="assign-B">assign-B</option>
                                                <option value="pickedup">pickedup</option>
                                                <option value="warehouse">warehouse</option>
                                                <option value="assign-D">assign-D</option>
                                                <option value="O-F-delivery">O-F-delivery</option>
                                                <option value="delivered">delivered</option>
                                                <option value="failed">failed</option>
                                                <option value="canceled">canceled</option>
                                            </select>
                                        </div>
                                    </div>
                                <div className="col-lg-2 col-md-4">
                                    <div className="form-group">
                                        <div className="form-check text-center mt-2">
                                            <input className="form-check-input" type="checkbox"onChange={this.changecollect}  id="invalidCheck2" required />
                                            <label className="form-check-label text-muted" htmlFor="invalidCheck2">
                                                COLLECT CASH
                                                </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-8 px-5">
                                <div className="form-group has-search my-0 mx-auto">
                                    <input type="text" className="form-control badge-pill" placeholder="search" value={this.state.search} name="search" onChange={this.handleChange}/>
                                    <img className="ml-2 mt--10 searchiconorders" src={searchicon} alt="search"/>

                                </div>
                                </div>
                            </div>
                        
                        <div className="allorder shadow  p-3 ">
                            <div className="row ">
                           <p className="col-6 mt-3 fontsize4">All Orders</p>
                           <div className="col-6 d-flex flex-row-reverse bd-highlight">
                                    <button className="btn badge-pill p-2 pl-1 px-3 m-2  border shadow bg-white p-2 bd-highlight" onClick={this.print} ><img className="mr-1" src={barcode} alt="barcode" />PRINT LABEL</button>
                                </div>
                            </div>
                            <table className="table  table-bordered ">
                                <thead className="thead-light fontsize12 text-muted ">
                                    <tr>
                                        <th scope="col "><input className="mx-1 rela" type="checkbox" value="" id="invalidCheck2" onClick={()=>this.handleaddalltoprint(currentdataorders)} checked={currentdataorders.length===this.state.dataprint.length?"checked":""}  />
                                            ORDER ID</th>
                                        <th scope="col">CLIENT</th>
                                        <th scope="col">DATE</th>
                                        <th scope="col">RECIVER</th>
                                        <th scope="col">ADDRESS</th>
                                        <th scope="col">CASH</th>
                                        <th scope="col">STATUS</th>
                                        <th scope="col">PRICE</th>
                                        <th scope="col">Edit</th>

                                    </tr>
                                </thead>
                                <tbody className="fontsize11 bg-white">
                                    
                                    {renderdataorders}
                                    
                                </tbody>
                               

                            </table>
                           
                                
                            <div className="row px-4 d-flex bd-highlight mb-3">
                                <div className="col mr-auto p-2 bd-highlight">
                                    <p>Total: {this.state.dataorders.length} order</p>
                                </div>
                                <div className="px-lg-5 p-2 bd-highligh">
                                        <div className="form-group  ">
                                            <select onChange={this.handleClick} id="inputState" className=" px-5 form-control  badge-pill  text-muted">
                                            {(renderPageNumbers.length===0?<option value="1"> 1 </option>:renderPageNumbers)}
                                            </select>
                                        </div>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                    <div id="divcontents"style={{
                                    height: '0px',
                                    width: '0px',
                                    position: 'absolute',
                                    visibility: 'hidden',
                                    display:'none'
                                }}>
                    {this.state.dataprint.map((x,i)=>(
                    <div className="modal-body col-12 mx-auto p-lg-4 "key={i} >
                    {/* <img className="m-2  " src={iconrightgreen} alt="close" />
                    <p className="fontsize4">Order status changed</p> */}
                    <p className="fontsize11  font-weight-bold Receiverde">Receiver details</p>
                    <div className="row pt-3" >
                        <div className="row  col-md-6  border-right">
                            {(x.ownerData.usecompanyinfo?
                            <div>
                                <div className="col-12 ">
                                <p className=" fontsize12 text-muted">Reciever :</p>&nbsp;	
                                <p className="fontsize11 ">{x.reciver.name}</p>

                            </div>
                            <div className="col-12  ">
                                <p className=" fontsize12 text-muted">Phone number :</p>&nbsp;	
                                <p className="fontsize11">{x.reciver.phone}</p>

                            </div>
                            <div className="col-12  ">
                                <p className=" fontsize12 text-muted">Company Name :</p>&nbsp;	
                                <p className="fontsize11 ">{x.ownerData.companyinfo.companyname}</p>

                            </div>
                            <div className="col-12  ">
                                <p className=" fontsize12 text-muted">Company Phone :</p>&nbsp;	
                                <p className="fontsize11 ">{x.ownerData.companyinfo.phone}</p>

                            </div>
                            </div>
                            :
                                <div>
                                    <div className="col-12 ">
                                    <p className=" fontsize12 text-muted ">Reciever : </p>&nbsp;	
                                    <p className="fontsize11 ml-2"> {x.reciver.name}</p>

                                    </div>
                                    <div className="col-12  ">
                                        <p className=" fontsize12 text-muted">Phone number : </p>&nbsp;	
                                        <p className="fontsize11 "> {x.reciver.phone}</p>

                                    </div>
                                    <p className="fontsize11  font-weight-bold ml-3">Sender details</p>&nbsp;	

                                    <div className="col-12 ">
                                    <p className=" fontsize12 text-muted">name : </p>&nbsp;	
                                    <p className="fontsize11 "> {x.ownerData.name}</p>

                                    </div>
                                    <div className="col-12  ">
                                        <p className=" fontsize12 text-muted">Phone : </p>&nbsp;	
                                        <p className="fontsize11 "> {x.ownerData.phone}</p>

                                    </div>
                                </div>
                        )}
                        </div>
                        <div className="col-md-6 text-center ">
                            <div className="mx-auto">
                                <QRCode
                                    bgColor="#FFFFFF"
                                    fgColor="#000000"
                                    level="Q"
                                    style={{ width: 180 }}
                                    value={x.qrcode}
                                />
                            </div>
                        </div>
                </div>
            </div>))}</div>
                                            <iframe id="ifmcontentstoprint" style={{
                                    height: '0px',
                                    width: '0px',
                                    position: 'absolute',
                                    visibility: 'hidden',
                                    display:'none'

                                }}><hr/></iframe> 
                </div>
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
{(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
{(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default AdminOrders;